const recommeneded_section = document.querySelector('.product-recommendations');

const options = {
  rootMargin: '400px'
}

const observer = new IntersectionObserver(entry => {

  if (entry[0].isIntersecting == true) {

    observer.unobserve(recommeneded_section);

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const url = productRecommendationsSection.dataset.url;
    
    fetch(url)
      .then(response => {
        if (!response.ok) {
          console.error("response was not ok");
          return null;
        }
        return response.text();
      })
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        
        // Set offset padding for large screens
        const screenWidth = window.innerWidth;
        const fcontainerWidth = 1440;
        const offsetDiff = Math.max(0, (screenWidth - fcontainerWidth) / 2);

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          const swiper_recommended = new window.swiper('.recommendations-slider', {
            slidesPerView: 1.5,
            spaceBetween: 16,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            breakpoints: {
              768: {
                slidesPerView: 2.5,
                slidesOffsetBefore: 58,
                slidesOffsetAfter: 58
              },
              1024: {
                slidesPerView: 3.5,
                slidesOffsetBefore: 58,
                slidesOffsetAfter: 58
              },
              1416: {
                slidesPerView: 3.5,
                slidesOffsetBefore: offsetDiff,
                slidesOffsetAfter: offsetDiff
              }
            },
            lazy: {
              enabled: true,
              checkInView: false,
              loadOnTransitionStart: true,
              loadPrevNext: true,
              loadPrevNextAmount: 1
            },
            pagination: {
              el: '.recommendations-swiper-counter', // Element to display pagination
              type: 'fraction', // Display fraction (e.g., 1/6)
            },
            navigation: {
              nextEl: '.recommendations-swiper-button-next',
              prevEl: '.recommendations-swiper-button-prev',
            },
          });
        }
        else {
          const recommendationsSection = document.querySelector('.recommended-products');
          recommendationsSection.style.display = 'none';
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

}, options);

observer.observe(recommeneded_section);
